// extracted by mini-css-extract-plugin
export default {"imgBox":"SimpleImgHolder_imgBox__jrEqF"};